/**
 * 服务端任务类型目录（N-167，单一真相源）——企业后台替员工在服务器上跑的每一处模型调用都声明自己属于
 * 哪一类任务；每类有一个推荐默认成本档。统一选模型函数（`task-model-chain.ts`）按「任务自带的档 >
 * 组织给该类换的档 > 本目录的默认档」定档。
 *
 * 飞书两类机器人（`feishu.role-bot` / `feishu.agent-bot`，N-182 P1 之二）与手机对话（`mobile.chat`，N-182 P4）带 `followBrain` 标记：不按档选模型，
 * 候选按平台默认主脑优先级跨两条引擎走（`resolveFeishuTurnModelChain`），组织也不能给它们换档
 * （{@link isOrgConfigurableTaskType}，维护者 2026-10-30「不能，始终跟主脑」）。
 *
 * 与 `task-type-meta.ts` 无关：那份是 SDK 后台任务（local_agent / dream …）的展示表。
 */
export const TASK_TYPE_IDS = [
    "cloud.model-call",
    "cloud.agent-turn",
    "cloud.feishu-event",
    "monitor.inspection",
    "monitor.ai-step",
    "memory.consolidation",
    "memory.distill",
    "capability.invoke",
    "feishu.role-bot",
    "feishu.agent-bot",
    "mobile.chat",
];
export const TASK_TYPE_CATALOG = [
    { id: "cloud.model-call", shape: "text", defaultTier: "economy", surface: "enterprise-backend", labelKey: "taskModel.type.cloudModelCall" },
    { id: "cloud.agent-turn", shape: "agent", defaultTier: "standard", surface: "agent-host", labelKey: "taskModel.type.cloudAgentTurn" },
    { id: "cloud.feishu-event", shape: "agent", defaultTier: "standard", surface: "agent-host", labelKey: "taskModel.type.cloudFeishuEvent" },
    { id: "monitor.inspection", shape: "agent", defaultTier: "standard", surface: "agent-host", labelKey: "taskModel.type.monitorInspection" },
    { id: "monitor.ai-step", shape: "text", defaultTier: "economy", surface: "enterprise-backend", labelKey: "taskModel.type.monitorAiStep" },
    { id: "memory.consolidation", shape: "text", defaultTier: "standard", surface: "enterprise-backend", labelKey: "taskModel.type.memoryConsolidation" },
    { id: "memory.distill", shape: "text", defaultTier: "standard", surface: "enterprise-backend", labelKey: "taskModel.type.memoryDistill" },
    { id: "capability.invoke", shape: "text", defaultTier: "economy", surface: "enterprise-backend", labelKey: "taskModel.type.capabilityInvoke" },
    { id: "feishu.role-bot", shape: "agent", defaultTier: "standard", surface: "feishu-bot", labelKey: "taskModel.type.feishuRoleBot", followBrain: true },
    { id: "feishu.agent-bot", shape: "agent", defaultTier: "standard", surface: "feishu-bot", labelKey: "taskModel.type.feishuAgentBot", followBrain: true },
    { id: "mobile.chat", shape: "agent", defaultTier: "standard", surface: "agent-host", labelKey: "taskModel.type.mobileChat", followBrain: true },
];
const TASK_TYPE_INDEX = new Map(TASK_TYPE_CATALOG.map((entry) => [entry.id, entry]));
export function isTaskTypeId(value) {
    return typeof value === "string" && TASK_TYPE_INDEX.has(value);
}
/**
 * 组织能不能给这类任务换档（`taskTypeTiers`）：目录里有、且不是跟随主脑的类型。组织清单的写入门
 * （admin-portal）、读侧整理（`sanitizeTaskTypeTiers`）与定档（`resolveTaskCostTier`）都按它判，
 * 不各写一份；跟随主脑的类型组织写了也不生效，写入接口按未知任务类型拒收。
 */
export function isOrgConfigurableTaskType(value) {
    if (typeof value !== "string")
        return false;
    const entry = TASK_TYPE_INDEX.get(value);
    return entry !== undefined && entry.followBrain !== true;
}
export function taskTypeEntry(id) {
    const entry = TASK_TYPE_INDEX.get(id);
    // 类型系统已保证 id 在目录里；运行时走到这里只可能是绕过类型的调用，明确失败而不是给个默认档。
    if (!entry)
        throw new Error(`[task-type-catalog] unknown task type: ${String(id)}`);
    return entry;
}
//# sourceMappingURL=task-type-catalog.js.map